import { useContext, useEffect, useState } from "react";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import { formatDateToDDMMAAAA } from "../../../../../functions/kit-mdtw/dates";
import { ICandidatoSolEnviada } from "../../../../../interfaces/ISeleccion";
import DropDownListCustomized from "../../../../ui/kit-mdtw/DropDownListCustomized";
import InputTextCustomized from "../../../../ui/kit-mdtw/InputTextCustomized";
import { IOptionDropDownList } from "../../../../../interfaces/IDropDownList";

interface IModalListadoSolicitarCandidato {
  rut: any[];
  solicitudes: any;
  setSolicitudes: Function;
  handleClickSolicitarCandidato: Function;
  onChangeBack: Function;
  onSelectProceso: Function;
  masivo?: boolean;
  destinoMasivoActive?: boolean;
  procesoDestinoMasivo?: string;
  comentarioMasivo?: string;
  candidateList?: any[];
}

export default (props: IModalListadoSolicitarCandidato) => {
  const {
    rut,
    solicitudes,
    setSolicitudes,
    handleClickSolicitarCandidato,
    onChangeBack,
    onSelectProceso,
    masivo,
    destinoMasivoActive,
    procesoDestinoMasivo,
    comentarioMasivo,
    candidateList,
  } = props;
  const { listaCandidatoNoDisponible, listProcesosActivos, getBusquedaProcesos, token } =
    useContext(SeleccionContext);
  const [currentData, setCurrentData] = useState<ICandidatoSolEnviada[]>([]);
  const [procesoOptions, setProcesoOptions] = useState<IOptionDropDownList[]>([]);
  const [formData, setFormData] = useState<any>({ procesoDestino: undefined });
  const [formComentarioRow, setFormComentarioRow] = useState<any>({ comentario: undefined });

  useEffect(() => {
    if (rut && listaCandidatoNoDisponible) {
      const current = listaCandidatoNoDisponible.filter(
        (item: ICandidatoSolEnviada) => rut.includes(item.personaDNI)
      );
      setCurrentData(current);
      const soli = current.map(
        ({ solicitudTraspasoId }: ICandidatoSolEnviada) => {
          return {
            solicitudTraspasoId,
            aceptar: true,
          };
        }
      );
      setSolicitudes(soli);
    }
  }, [rut]);

  useEffect(() => {
    if (listProcesosActivos?.data) {
      const options: IOptionDropDownList[] = [];
      listProcesosActivos.data.forEach(({ clienteNombre, grupos }: any) => {
        grupos.forEach(({ procesos }: any) => {
          procesos.forEach(({ busquedaId, cargoNombre }: any) => {
            options.push({
              name: `${busquedaId} · ${clienteNombre} · ${cargoNombre}`,
              code: busquedaId,
            });
          });
        });
      });
      setProcesoOptions(options);
    } else if (token) {
      getBusquedaProcesos({ token, filtros: { tipoProceso: "MASIVO" }, setIsErrorTable: () => {} });
    }
  }, [listProcesosActivos]);

  useEffect(() => {
    if (!procesoDestinoMasivo) {
      const selected = formData.procesoDestino?.value?.code;
      onSelectProceso(selected);
    }
  }, [formData, procesoDestinoMasivo]);

  return (
    <>
      {rut &&
        currentData.map((item: any) => {
          const {
            busquedaId,
            personaDNI,
            primerApellido,
            primerNombre,
            reclutador,
            fechaPosutlacion,
          } = item;

          return (
            <tr className="tr-table-restaurar" key={personaDNI}>
              <td className="td-table-restaurar" data-label="Rut">{personaDNI}</td>
              <td className="td-table-restaurar" data-label="Nombre">
                {primerNombre} {primerApellido}
              </td>
              <td className="td-table-restaurar" data-label="Fecha Postulación">
                {formatDateToDDMMAAAA({
                  date: fechaPosutlacion,
                  format: "/",
                })}
              </td>
              <td className="td-table-restaurar" data-label="Reclutador">{reclutador}</td>
              <td className="td-table-restaurar" data-label="ID Origen">{busquedaId}</td>
              <td className="td-table-restaurar" data-label="ID Destino">
                <div style={{ width: "clamp(340px, 32vw, 480px)", margin: "0 auto" }}>
                  <DropDownListCustomized
                    list={procesoOptions}
                    placeholder="Seleccione proceso"
                    errorPosition="down"
                    onValueChange={setFormData}
                    onPermaValues={formData}
                    onPropertyChange="procesoDestino"
                    disabled={!!destinoMasivoActive}
                  />
                </div>
              </td>
              {masivo && (
                <td className="td-table-restaurar" data-label="Comentario">
                  <InputTextCustomized
                    layer=""
                    placeholder="Comentario (opcional)"
                    required={false}
                    errorPosition="down"
                    onValueChange={setFormComentarioRow}
                    onPermaValues={formComentarioRow}
                    onPropertyChange="comentario"
                    disabled={comentarioMasivo !== undefined}
                  />
                </td>
              )}
            </tr>
          );
        })}
    </>
  );
};
